import React, { useEffect, useState, useContext } from 'react';
import { Button as MUIButton, Chip, Stack } from '@mui/material';
import { Row, Col, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import {Link} from 'react-router-dom'

export default function ViewPartner() {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();

  // State for partner details
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch partner details on mount
  useEffect(() => {
    const fetchPartner = async () => {
      setLoading(true);
      try {
        const response = await postRequest(`private/viewPartner/${id}`, {}, authCtx.token);
        if (response?.status === 200 && response?.data) {
          setPartner(response.data);
        }
      } catch (err) {
        // Optionally show error
      }
      setLoading(false);
    };
    fetchPartner();
  }, [id, authCtx.token]);

  // Delete user handler
  const handleDelete = async (userId) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this partner?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      try {
        const response = await postRequest(`private/DeletePartner/${userId}`, {}, authCtx.token);
        if (response?.status === 200 || response?.success) {
          Swal.fire('Deleted!', 'User group has been deleted.', 'success');
          navigate(-1);
        } else {
          Swal.fire('Error', response?.message || 'Failed to delete user', 'error');
        }
      } catch (err) {
        Swal.fire('Error', err?.message || 'Failed to delete user', 'error');
      }
    }
  };

  if (loading) {
    return (
      <div className="p-4">
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Partners', path: '/partners' },
            { label: 'View Partner', path: '' },
          ]}
        />
        <br />
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-4">
      {/* Top Header */}
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Partners', path: '/partners' },
          { label: 'View Partner', path: '' },
        ]}
      />
      <br />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{partner?.name || '-'}</h3>
        <div>
          <MUIButton
            variant="contained"
            color="error"
            size="small"
            style={{ marginRight: 8 }}
            onClick={() => handleDelete(id)}
          >
            Delete
          </MUIButton>
          <MUIButton
            variant="outlined"
            size="small"
            onClick={() => navigate(`/partners/edit/${id}`)}
          >
            Edit
          </MUIButton>
        </div>
      </div>

      {/* Product Tags */}
      <div className="mb-4">
        <Stack direction="row" spacing={1}>
          {partner?.product_names && partner.product_names.length > 0 ? (
            partner.product_names.map((title) => (
              <Chip key={title} label={title} color="default" variant="outlined" />
            ))
          ) : (
            <Chip label="No Products" color="default" variant="outlined" />
          )}
            {/* MLM Branches & Automation */}
    {partner?.uses_mlm_branches && (
      <Chip label="MLM Branches Enabled"  sx={{ color: '#1976d2' }} variant="filled" />
    )}
    {partner?.uses_mlm_automation && (
      <Chip label="MLM Automation Enabled"  sx={{ color: '#1976d2' }} variant="filled" />
    )}
        </Stack>
      </div>

      <Row>
        {/* Users List */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0">Users</h6>
                <MUIButton
                  variant="text"
                   sx={{ color: '#1976d2' }}
                  size="small"
                 onClick={() => navigate(`/users/create?partner_id=${partner?._id}`)}
                  style={{ textTransform: 'none' }}
                >
                  Create User
                </MUIButton>
              </div>
 <ul className="list-unstyled mb-0">
  {Array.isArray(partner?.user_name) && partner.user_name.length > 0 ? (
    partner.user_name.map((user, index) => (
      <li key={index} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to={`/user/view/${user.id}`} style={{ color: '#1976d2', textDecoration: 'underline' }}>
          {user?.name}
        </Link>
        <span style={{ fontSize: '0.9em', color: '#666' }}>
          {user?.username}
        </span>
      </li>
    ))
  ) : (
    <li>-</li>
  )}
</ul>


            </Card.Body>
          </Card>
        </Col>

        {/* User Groups */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0">User Groups</h6>
                <MUIButton
                  variant="text"
                  sx={{ color: '#1976d2' }}
                  size="small"
                  onClick={() => navigate(`/user-groups/create`)}
                  style={{ textTransform: 'none' }}
                >
                  Create Group
                </MUIButton>
              </div>
              <ul className="list-unstyled mb-0">
                {Array.isArray(partner?.user_groups) && partner.user_groups.length > 0 ? (
                  partner.user_groups.map((group) => (
                    <li key={group.id} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Link to={`/user-groups/view/${group.id}`} style={{ color: '#1976d2', textDecoration: 'underline' }}>
                        {group.title}
                      </Link>
                      {group.is_default && (
                        <Chip label="Default" size="small" color="primary" sx={{ height: '20px', fontSize: '0.75rem' }} />
                      )}
                    </li>
                  ))
                ) : (
                  <li>-</li>
                )}
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}